import { render, staticRenderFns } from "./SettingsTechnicalWork.vue?vue&type=template&id=0108ea58&"
import script from "./SettingsTechnicalWork.vue?vue&type=script&lang=js&"
export * from "./SettingsTechnicalWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports